/*
 * File: EmailVerification.tsx
 * Project: a-a
 * File Created: Friday, 11th October 2024 7:03:39 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 23rd July 2025 11:31:22 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React, { useState } from 'react';
import styles from './EmailVerification.module.css';
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import EntryLayoutScreen from '../../components/shared/EntryLayout/EntryLayout';
import CustomButton from '../../components/shared/CustomButton/CustomButton';
import zeplinColor from '../../theme/Color';
import RoutePaths from '../../routes/RoutePaths';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { Link } from 'react-router-dom';
import { AuthService } from '../../service/auth.service';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WifiOffRoundedIcon from '@mui/icons-material/WifiOffRounded';
import { Constants } from '../../utilities/constants';

const EmailVerification = () => {
  const newUser = sessionStorage.getItem('register-user') || '';
  const [alert, setAlert] = useState('');
  const [error, setError] = useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const resendConfirm = async () => {
    try {
      handleOpen();
      const req = await AuthService.resendConfirm({ userName: newUser });
      console.log(req?.$metadata?.httpStatusCode);
      if (req?.$metadata?.httpStatusCode) {
        setAlert('Email Sent');
      }
    } catch (err: any) {
      console.log(err);
      setError(true);
      if (err?.response?.data?.name === Constants.ErrorType.LimitExceeded) {
        setAlert(Constants.ErrorText['LimitExceededException']);
      } else {
        setAlert("Oops! You're offline. Reconnect to continue");
      }
    } finally {
      handleClose();
    }
  };
  const handleDefaultAlert = () => {
    setAlert('');
    setError(false);
  };
  const children = (
    <div className={styles['verification-container']}>
      <div className={styles['buttons-grid']}>
        <Link
          to='https://mail.google.com'
          target='_blank'
          rel='noopener noreferrer'
          className={styles['link-verify']}
        >
          <CustomButton
            disabled={false}
            onClick={() => {}}
            variant='outlined'
            color='secondary'
            style={{
              width: '100%',
              borderRadius: '14px',
              height: 56,

              gap: '16px',
            }}
            textStyle={{ color: zeplinColor.BasicBlack }}
            text={'Open Gmail'}
            icon={<img src={'assets/gmail-logo.svg'} />}
          />
        </Link>
        <Link
          to='https://outlook.office365.com/mail/inbox'
          target='_blank'
          rel='noopener noreferrer'
          className={styles['link-verify']}
        >
          <CustomButton
            disabled={false}
            onClick={() => {}}
            variant='outlined'
            color='secondary'
            style={{ width: '100%', borderRadius: '14px', height: 56, gap: '16px' }}
            textStyle={{ color: zeplinColor.BasicBlack }}
            text={'Open Outlook'}
            icon={<img src={'assets/outlook-logo.svg'} />}
          />
        </Link>
      </div>
      <CustomButton
        disabled={false}
        onClick={resendConfirm}
        variant='text'
        text={'Resend Email'}
        textStyle={{ color: zeplinColor.Brand1 }}
      />
    </div>
  );
  const alternative = '';

  return (
    <EntryLayoutScreen
      header={'Check your inbox'}
      subheader={`We sent you an email to ${newUser} You're one step away from verifying your account.`}
      input={children}
      clickAction={() => {}}
      alternative={alternative}
      footerText='Already have an account? '
      footerButtonText='Log in'
      path={RoutePaths.Root}
      icon={
        <div
          style={{
            backgroundColor: zeplinColor.Neutral3,
          }}
          className={styles['verify-email-logo']}
        >
          <img src={'/assets/mail.svg'} width={40} height={40} />
        </div>
      }
      alert={alert}
      error={error}
      handleClose={handleDefaultAlert}
      alertIcon={
        error ? (
          <WifiOffRoundedIcon style={{ color: zeplinColor.Neutral1, width: 18, height: 18 }} />
        ) : (
          // <CheckCircleOutlineIcon style={{ color: zeplinColor.Success, width: 24, height: 24 }} />
          <img src='/assets/check-outlined.svg' width={24} height={24} />
        )
      }
      handleCloseModal={handleClose}
      open={open}
    />
  );
};

export default EmailVerification;
